/**
 * @file Analytics methods for google analytics and rudderstack
 */
const trackEvent = function (category, action, label, value) {
  if (window.rudderanalytics && window.$pepinUser) {
    const rudderEvent = 'user_action'
    const rudderProperties = { category, action, label, value }
    const rudderOptions = { traits: window.$pepinUser }
    window.rudderanalytics.track(rudderEvent, rudderProperties, rudderOptions)
  }
}

export { trackEvent }
